// EkBharatShreshthaBharat
import React from 'react';

import ClassLeader6to82025 from 'views/ClassLeader6to82025';

const EkBharatShreshthaBharatPage = () => {
  return <ClassLeader6to82025 />;
};

export default EkBharatShreshthaBharatPage;